import { capitalize } from "lodash";

import { FieldRequestFieldEnum } from "@/features/common/enums";

export enum FieldRequestType {
  COLLATERAL = "COLLATERAL",
  ADDITIONAL_INFORMATION = "ADDITIONAL_INFORMATION",
}

export const GUARANTORS_FIELD = "guarantors";

export const PARENT_COMPANY_FIELD = "parent_company_guarantee";

export const PROPERTY_FIELD = "property";

export const PROPERTY_ADDITIONAL_DATA_FIELD = "property_additional_data";

export const COMPANY_MORTGAGE_FIELD = "company_mortgage";

export const SHARE_MORTGAGE_FIELD = "share_mortgage";

export const PAWNED_INVOICES_FIELD = "pawned_invoices";

export const REASON_FIELD = "reason";

export const REASON_EXPLANATION_FIELD = "reason_explanation";

export const ACCOUNTING_DATA_FIELD = "accounting_data";

export const CONSTRUCTION_ESTIMATE_FIELD = "construction_estimate";

export const BANKING_DATA_FIELD = "banking_data";

export const UNPAID_INVOICES_FIELD = "unpaid_invoices";

export const UNPAID_INVOICES_ADDITIONAL_DATA_FIELD =
  "unpaid_invoices_additional_data";

export const LEASING_FIELD = "leasing";

export const LEASING_ADDITIONAL_DATA_FIELD = "leasing_additional_data";

export const BUDGET_FIELD = "budget";

export const ADDITIONAL_SECURITIES_FIELD = "additional_securities";

export const BUILDING_PERMIT_FIELD = "building_permit";

export const PROPERTY_CASH_FLOW_FIELD = "property_cash_flow";

export const SELF_ESTIMATED_HISTORIC_REVENUE_FIELD =
  "self_estimated_historic_revenue";

export const SELF_ESTIMATED_REVENUE_FIELD = "self_estimated_revenue";

export const ADDITIONAL_INFORMATION_FIELD = "additional_information";

export const FIELD_REQUESTS_NAMES = {
  GUARANTORS_FIELD,
  PARENT_COMPANY_FIELD,
  PROPERTY_FIELD,
  PROPERTY_ADDITIONAL_DATA_FIELD,
  COMPANY_MORTGAGE_FIELD,
  SHARE_MORTGAGE_FIELD,
  PAWNED_INVOICES_FIELD,
  REASON_FIELD,
  REASON_EXPLANATION_FIELD,
  ACCOUNTING_DATA_FIELD,
  CONSTRUCTION_ESTIMATE_FIELD,
  BANKING_DATA_FIELD,
  UNPAID_INVOICES_FIELD,
  UNPAID_INVOICES_ADDITIONAL_DATA_FIELD,
  LEASING_FIELD,
  LEASING_ADDITIONAL_DATA_FIELD,
  BUDGET_FIELD,
  ADDITIONAL_SECURITIES_FIELD,
  BUILDING_PERMIT_FIELD,
  PROPERTY_CASH_FLOW_FIELD,
  SELF_ESTIMATED_HISTORIC_REVENUE_FIELD,
  SELF_ESTIMATED_REVENUE_FIELD,
  ADDITIONAL_INFORMATION_FIELD,
};

export const FIELD_REQUESTS_LABELS = {
  [GUARANTORS_FIELD]: capitalize(GUARANTORS_FIELD.replace(/[_]+/g, " ")),
  [PARENT_COMPANY_FIELD]: capitalize(
    PARENT_COMPANY_FIELD.replace(/[_]+/g, " "),
  ),
  [PROPERTY_FIELD]: capitalize(PROPERTY_FIELD.replace(/[_]+/g, " ")),
  [COMPANY_MORTGAGE_FIELD]: capitalize(
    COMPANY_MORTGAGE_FIELD.replace(/[_]+/g, " "),
  ),
  [SHARE_MORTGAGE_FIELD]: capitalize(
    SHARE_MORTGAGE_FIELD.replace(/[_]+/g, " "),
  ),
  [PAWNED_INVOICES_FIELD]: capitalize(
    PAWNED_INVOICES_FIELD.replace(/[_]+/g, " "),
  ),
  [REASON_FIELD]: capitalize(REASON_FIELD.replace(/[_]+/g, " ")),
  [REASON_EXPLANATION_FIELD]: "Reason explanation",
  [ACCOUNTING_DATA_FIELD]: capitalize(
    ACCOUNTING_DATA_FIELD.replace(/[_]+/g, " "),
  ),
  [FieldRequestFieldEnum.annual_report]: "Latest financial report",
  [CONSTRUCTION_ESTIMATE_FIELD]: capitalize(
    CONSTRUCTION_ESTIMATE_FIELD.replace(/[_]+/g, " "),
  ),
  [BANKING_DATA_FIELD]: capitalize(BANKING_DATA_FIELD.replace(/[_]+/g, " ")),
  [UNPAID_INVOICES_FIELD]: capitalize(
    UNPAID_INVOICES_FIELD.replace(/[_]+/g, " "),
  ),
  [UNPAID_INVOICES_ADDITIONAL_DATA_FIELD]: "Accounts ledger",
  [LEASING_FIELD]: "Leasing object",
  [LEASING_ADDITIONAL_DATA_FIELD]: "Leasing offer / contract",
  [BUDGET_FIELD]: capitalize(BUDGET_FIELD.replace(/[_]+/g, " ")),
  [ADDITIONAL_SECURITIES_FIELD]: "Additional information",
  [BUILDING_PERMIT_FIELD]: capitalize(
    BUILDING_PERMIT_FIELD.replace(/[_]+/g, " "),
  ),
  [PROPERTY_CASH_FLOW_FIELD]: capitalize(
    PROPERTY_CASH_FLOW_FIELD.replace(/[_]+/g, " "),
  ),
  [SELF_ESTIMATED_HISTORIC_REVENUE_FIELD]: capitalize(
    SELF_ESTIMATED_HISTORIC_REVENUE_FIELD.replace(/[_]+/g, " "),
  ),
  [SELF_ESTIMATED_REVENUE_FIELD]: capitalize(
    SELF_ESTIMATED_REVENUE_FIELD.replace(/[_]+/g, " "),
  ),
  [ADDITIONAL_INFORMATION_FIELD]: capitalize(
    ADDITIONAL_INFORMATION_FIELD.replace(/[_]+/g, " "),
  ),
  [PROPERTY_ADDITIONAL_DATA_FIELD]: "Valuation",
};
